import { type StripeElementsOptions } from "@stripe/stripe-js";
import React from "react";
import { Button } from "semantic-ui-react";
import StripePaymentMethod from "./StripePaymentMethod";

interface Props {
  options: StripeElementsOptions
  returnUrl: string
  hasIgnoredWarning: boolean
  onWarningIgnored: () => void
  onHasLoaded: () => void
  isLoading: boolean
  height: number
}

const Card = (props: Props) => {
  if (!props.hasIgnoredWarning) {
    return <div
      style={{ height: props.height }}
      className="flex-column align-center justify-center lightblue-bg s1_blue"
    >
      <div className="margin-bottom-larger" style={{ maxWidth: 500, textAlign: "center", lineHeight: "1.5em" }}>
        When you have the option, we appreciate when you pay via SEPA debit.<br />
        This saves SystemOne payment processing fees.<br />
        But even if you use your card, we&apos;re happy &amp; grateful for your customership. :)
      </div>

      <div>
        <Button color="blue" onClick={props.onWarningIgnored}>
          I&apos;d like to use a card
        </Button>
      </div>
    </div>;
  }

  return <StripePaymentMethod
    clientSecret={props.options.clientSecret}
    returnUrl={props.returnUrl}
    onHasLoaded={props.onHasLoaded}
    isLoading={props.isLoading}
  />;
};

export default Card;